import React, { memo } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Rep } from '../../../classes/Workout';
import { State } from '../../../reducers';
import LiveGraphExercises from './LiveGraphExercises';

interface LiveGraphWithContextProps {
    currentRep: Rep;
    activityStatus: string;
    chartDataArray?: { x: number; y: number }[];
    elapsedTime?: number; // Add elapsed time prop
    dispatch: Dispatch<any>;
}


const LiveGraphExercisesWithContext: React.FC<LiveGraphWithContextProps> = memo(() => {
    // Chart data is now handled directly by LiveGraphExercises via Redux store
    // No need for context processing here - just render the component directly
    
    return <LiveGraphExercises />;
});

const mapStateToProps = (state: State) => ({
    currentRep: state.activities.currentRep,
    activityStatus: state.activities.activityStatus,
});

export default connect(mapStateToProps)(LiveGraphExercisesWithContext);
